import React from "react";
import { Flex } from "antd";
import ModalComponent from "@/components/modal";

const MembershipDescription = ({ isOpen, message = "" }) => {
  return (
    <ModalComponent isOpen={isOpen} width={300} closeIcon>
      <Flex vertical gap="1rem" align="center">
        <div className="body-b1 text-center">{message}</div>
      </Flex>
    </ModalComponent>
  );
};

export default MembershipDescription;
